import { black } from 'theme';

const borderColor = '#EAECF0';

const styles = {
  container: {
    marginTop: '30px',
    position: 'relative',
  },
  card: {
    borderRadius: '8px',
    border: `1px solid ${borderColor}`,
    padding: '24px',
    position: 'relative',
  },
  generalInformationCard: {
    paddingTop: '110px',
    position: 'relative',
  },
  avatar: {
    height: '140px',
    width: '140px',
    position: 'absolute',
    top: '-55px',
    background: 'white',
    border: `1px solid ${borderColor}`,
  },
  name: {
    fontSize: '26px',
    fontWeight: '600',
  },
  title: {
    fontSize: '16px',
    color: `${black}CC`,
  },
  chips: {
    paddingTop: '16px',
    flexWrap: 'wrap',
    display: 'flex',
    gap: '8px',
  },
  chip: {
    padding: '4px 8px',
    borderRadius: '16px',
    border: '1px solid',
    width: 'max-content',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
  },
  chipIcon: {
    fontSize: '0.9rem',
    marginRight: '4px',
  },
  purpleChip: {
    color: '#2B18A2',
    borderColor: '#2B18A299',
    background: '#F3F1FF',
  },
  greenChip: {
    color: '#0A7A3D',
    borderColor: '#0A7A3D299',
    background: '#E3FCEE',
  },
  blackChip: {
    color: '#32313B',
    borderColor: '#32313B299',
    background: '#F2F2F2',
  },
  redChip: {
    color: '#BE1622',
    borderColor: '#BE162299',
    background: '#FFF2F3',
  },
  containerContactDetails: {
    marginTop: '24px',
  },
  contactDetailsTitle: {
    textTransform: 'uppercase',
    fontWeight: '600',
    fontSize: '16px',
    marginBottom: '12px',
  },
  iconContractDetails: {
    width: '16px',
    marginRight: '6px',
    color: '#0000008A',
  },
  valueContractDetails: {
    fontSize: '14px',
  },
  contactDetailsLine: {
    height: '30px',
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
  },
  containerMeet: {
    marginTop: '24px',
    marginBottom: '8px',
  },
  secondaryTitle: {
    textTransform: 'uppercase',
    fontSize: '12px',
    color: 'primary.grey',
    marginBottom: '8px',
  },
  contentMeet: {
    flexWrap: 'wrap',
    display: 'flex',
    gap: '16px',
  },
  meetItem: {
    display: 'flex',
    alignItems: 'center',
  },
  meetItemIcon: {
    color: 'primary.grey',
    marginRight: '4px',
  },
  aboutMeTitle: {
    fontWeight: 600,
    fontSize: '18px',
    marginBottom: '16px',
  },
  aboutMeValue: {
    fontSize: {
      xs: '13px',
      sm: '14px',
    },
  },
  directionalArrowsContainer: {
    position: 'absolute',
    top: '16px',
    right: '16px',
  },
  directionalLeft: {
    marginRight: '10px',
  },
  directionArrow: {
    minWidth: '32px !important',
    height: '32px !important',
    padding: '0  !important',
    color: '#475467',
    borderColor: 'primary.border',
  },
  editButton: {
    position: 'absolute',
    right: '0px',
    top: '-35px',
  },
};

export default styles;
